import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSiteUrl } from "../utils/seo";

// La home vive en la web nueva (Next). Si la app antigua llega a «/», «/es»
// o «/en» navegando por dentro (logo, tras iniciar sesión…), se recarga la
// página entera para que la sirva Next. Se usa la URL absoluta del sitio
// para no entrar en bucle si la app antigua se abre en su propio dominio.
// `to` sirve para otras páginas que ya viven en Next («Crear viaje»).
export default function HomeRedirect({ lang = "es", to }) {
  useEffect(() => {
    const path = to || `/${lang === "en" ? "en" : "es"}`;
    window.location.replace(`${getSiteUrl()}${path}${window.location.search}`);
  }, [lang, to]);
  return null;
}

// Páginas de ciudad (/es/viajes-en/:city): también son de Next
export function CityTripsRedirect() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.location.replace(`${getSiteUrl()}${pathname}`);
  }, [pathname]);
  return null;
}
